import React from "react";
import { Helmet } from "react-helmet-async";
import "./styles/Cgu.css";

const Cgu = () => {
  return (
    <main className="cgu">
      <Helmet>
        <title>Conditions Générales d'Utilisation (CGU) - WinlyDeal</title>

        <meta 
          name="description" 
          content="Découvrez les Conditions Générales d'Utilisation (CGU) de WinlyDeal : accès au service, responsabilités, protection des données, paiements sécurisés et propriété intellectuelle." 
        />
        <meta 
          name="keywords" 
          content="CGU, Conditions Générales d'Utilisation, WinlyDeal, accès service, données personnelles, propriété intellectuelle, paiements sécurisés"
        />
        <link rel="canonical" href="https://winlydeal.com/cgu" />
        
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="CGU - Conditions Générales d'Utilisation | WinlyDeal" />
        <meta 
          property="og:description" 
          content="Consultez les CGU de WinlyDeal pour connaître vos droits, obligations et les conditions d'utilisation de notre plateforme de contributions gagnantes." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://winlydeal.com/cgu" />
        <meta property="og:image" content="https://winlydeal.com/images/og-image.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="CGU - Conditions Générales d'Utilisation | WinlyDeal" />
        <meta 
          name="twitter:description" 
          content="Découvrez les règles d'utilisation, responsabilités et protections de données en utilisant WinlyDeal." 
        />
        <meta name="twitter:image" content="https://winlydeal.com/images/og-image.jpg" />
      </Helmet>

      <h1 className="cgu-title">Conditions Générales d'Utilisation (CGU)</h1>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">1. Acceptation des Conditions</h2>
        <p className="cgu-text">
          En utilisant WinlyDeal, vous acceptez sans réserve les présentes Conditions Générales d'Utilisation (CGU).
        </p>
      </section>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">2. Accès au Service</h2>
        <p className="cgu-text">
          La plateforme WinlyDeal est accessible 24h/24 et 7j/7, sauf cas de force majeure, événement imprévisible ou maintenance technique.
        </p>
      </section>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">3. Conditions de Participation</h2>
        <p className="cgu-text">
          L'accès à WinlyDeal est réservé aux personnes majeures ou disposant de l'autorisation d'un représentant légal. Chaque utilisateur doit fournir des informations exactes lors de son inscription.
        </p>
      </section>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">4. Responsabilités</h2>
        <p className="cgu-text">
          WinlyDeal ne peut être tenu responsable des interruptions de service, erreurs ou dommages liés à l'utilisation de la plateforme.
        </p>
      </section>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">5. Données Personnelles</h2>
        <p className="cgu-text">
          Les données personnelles collectées par WinlyDeal sont traitées conformément au RGPD et utilisées uniquement pour le fonctionnement de la plateforme.
        </p>
      </section>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">6. Paiement et Tiers</h2>
        <p className="cgu-text">
          Les paiements sur WinlyDeal sont sécurisés via notre partenaire Stripe. Nous n'avons jamais accès à vos informations bancaires.
        </p>
      </section>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">7. Propriété Intellectuelle</h2>
        <p className="cgu-text">
          Tous les contenus publiés sur WinlyDeal sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle.
        </p>
      </section>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">8. Modification des CGU</h2>
        <p className="cgu-text">
          WinlyDeal se réserve le droit de modifier à tout moment les présentes Conditions Générales d'Utilisation. Les modifications prendront effet dès leur publication en ligne.
        </p>
      </section>

      <section className="cgu-section">
        <h2 className="cgu-subtitle">9. Droit Applicable</h2>
        <p className="cgu-text">
          Les CGU de WinlyDeal sont régies par le droit français. En cas de litige, seuls les tribunaux français seront compétents.
        </p>
      </section>
    </main>
  );
};

export default Cgu;
